import { api } from "../config/api";
import { post } from "../api";

export interface TagsSessionArgs {
  business_id: string | null;
  device_token: string | null;
  session_id: string | null;
}

export interface TagApiItem {
  tag_id?: string;
  name: string;
  description?: string;
  color?: string;
  shortcode?: string;
  tag_shortcode?: string;
}

export interface GetBusinessTagsArgs extends TagsSessionArgs {
  page_number?: number;
  page_size?: number;
}

export interface GetBusinessTagsResponse {
  success?: boolean;
  data?: {
    business_tags_info?: TagApiItem[];
    pagination?: { total_items?: number };
  };
  errors?: string;
}

export interface CreateTagPayload extends TagsSessionArgs {
  tag_id?: string;
  name: string;
  description?: string;
  shortcode?: string;
  is_deleted?: boolean;
  color?: string;
}

export interface CreateTagResponse {
  success?: boolean;
  errors?: string;
}

export interface DeleteTagPayload extends TagsSessionArgs {
  tag_id: string;
}

export interface DeleteTagResponse {
  success?: boolean;
  errors?: string | string[];
}

function getBusinessTags(args: GetBusinessTagsArgs): Promise<GetBusinessTagsResponse> {
  const { business_id, device_token, session_id, page_number = 1, page_size = 1000 } = args;
  if (!business_id || !device_token || !session_id) {
    return Promise.reject("business_id, device_token and session_id are required");
  }
  return post<GetBusinessTagsResponse>(api.GET_BUSINESS_TAGS, {
    business_id,
    device_token,
    session_id,
    page_number,
    page_size,
  });
}

export interface GetAllBusinessTagsResponse {
  success?: boolean;
  data?: { business_tags_info?: TagApiItem[] };
  errors?: string;
}

function getAllBusinessTags(args: TagsSessionArgs): Promise<GetAllBusinessTagsResponse> {
  const { business_id, device_token, session_id } = args;
  if (!business_id || !device_token || !session_id) {
    return Promise.reject("business_id, device_token and session_id are required");
  }
  return post<GetAllBusinessTagsResponse>(api.GET_ALL_BUSINESS_TAGS, {
    business_id,
    device_token,
    session_id,
  });
}

function createTag(payload: CreateTagPayload): Promise<CreateTagResponse> {
  const { business_id, device_token, session_id } = payload;
  if (!business_id || !device_token || !session_id) {
    return Promise.reject("business_id, device_token and session_id are required");
  }
  return post<CreateTagResponse>(api.CREATE_TAG, {
    ...payload,
    shortcode: payload.shortcode ?? "",
  });
}

function deleteTag(payload: DeleteTagPayload): Promise<DeleteTagResponse> {
  const { business_id, device_token, session_id, tag_id } = payload;
  if (!business_id || !device_token || !session_id || !tag_id) {
    return Promise.reject("business_id, device_token, session_id and tag_id are required");
  }
  return post<DeleteTagResponse>(api.DELETE_TAGS, payload);
}

export const tagsService = {
  getBusinessTags,
  getAllBusinessTags,
  createTag,
  deleteTag,
};
